/**
 * 模块: PeriodListPanel
 * 职责: 周期详细列表折叠面板组件
 * 限制: <280行
 */

import React from 'react';
import { Collapse, Table, Tag } from 'antd';
import type { SearchPerformancePeriod } from '../../../types';

interface PeriodListPanelProps {
  periods: SearchPerformancePeriod[];
  periodsLoading: boolean;
}

export const PeriodListPanel: React.FC<PeriodListPanelProps> = ({
  periods,
  periodsLoading,
}) => {
  const statusMap: Record<string, { color: string; text: string }> = {
    completed: { color: 'success', text: '已完成' },
    processing: { color: 'processing', text: '处理中' },
    failed: { color: 'error', text: '失败' },
    pending: { color: 'default', text: '待处理' },
  };

  return (
    <Collapse 
      defaultActiveKey={[]} 
      style={{ marginBottom: 24 }}
      items={[
        {
          key: 'periods',
          label: `周期详细列表 (共 ${periods.length} 个周期)`,
          children: (
            <Table
              dataSource={periods}
              loading={periodsLoading}
              rowKey="id"
              size="small"
              pagination={{ pageSize: 10 }}
              columns={[
                { title: '周期', dataIndex: 'period_label', key: 'period_label' },
                { title: 'ASIN', dataIndex: 'asin', key: 'asin' },
                { 
                  title: '搜索词数', 
                  dataIndex: 'total_keywords', 
                  key: 'total_keywords',
                  render: (val: number) => val?.toLocaleString() || 0
                },
                { 
                  title: '总曝光', 
                  dataIndex: 'total_impressions', 
                  key: 'total_impressions',
                  render: (val: number) => val?.toLocaleString() || 0
                },
                { 
                  title: '总点击', 
                  dataIndex: 'total_clicks', 
                  key: 'total_clicks',
                  render: (val: number) => val?.toLocaleString() || 0
                },
                { title: '报告日期', dataIndex: 'report_date', key: 'report_date' },
                { 
                  title: '状态', 
                  dataIndex: 'status', 
                  key: 'status',
                  render: (status: string) => {
                    const config = statusMap[status] || { color: 'default', text: status };
                    return <Tag color={config.color}>{config.text}</Tag>;
                  }
                },
              ]}
            />
          )
        }
      ]}
    />
  );
};

